import { Autorenew } from "@mui/icons-material";
import { Alert, Typography } from "@mui/material";

import BaseModal from "../components/BaseModal";

interface ReprocessInvoiceModalProps {
  open: boolean;
  loading?: boolean;
  invoiceNo: string;
  /** Approved invoices get a stronger warning: a clean re-read sends them back for approval. */
  isApproved: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function ReprocessInvoiceModal({
  open,
  loading,
  invoiceNo,
  isApproved,
  onClose,
  onConfirm,
}: ReprocessInvoiceModalProps) {
  return (
    <BaseModal
      open={open}
      title="Reprocess this invoice?"
      loading={loading}
      confirmLabel="Reprocess"
      confirmIcon={<Autorenew sx={{ fontSize: 18 }} />}
      onClose={onClose}
      onConfirm={onConfirm}
    >
      <Typography variant="body1" color="textPrimary">
        The document for invoice <strong>{invoiceNo}</strong> will be read again, and the invoice will go
        through validation and matching again.
      </Typography>
      <Typography variant="body2" color="textSecondary" mt={1}>
        If the new read is clean, the invoice moves back to processing and may need review or approval
        again. If it fails, nothing changes. This can take a few minutes.
      </Typography>
      {isApproved && (
        <Alert severity="warning" sx={{ mt: 2 }}>
          This invoice is already approved. Reprocessing will take it out of Approved until validation
          and matching finish again.
        </Alert>
      )}
    </BaseModal>
  );
}
